import { api } from './api';

// `source` names the channel minting the link (migration 073). Omitted means
// 'app' — the SPA panel, which is also the only surface that lists every link.
export async function createIntakeLink(displayName, sentTo, { source } = {}) {
  return await api.post('/api/intake-links', source ? { displayName, sentTo, source } : { displayName, sentTo });
}
export async function listIntakeLinks({ source } = {}) {
  const res = await api.get('/api/intake-links' + (source ? `?source=${encodeURIComponent(source)}` : ''));
  return res.links || [];
}
export async function resendIntakeLink(id) {
  return await api.post(`/api/intake-links/${id}/resend`, {});
}
export async function retryIntakeLink(id) {
  return await api.post(`/api/intake-links/${id}/retry`, {});
}
// Stop a link the patient can still use. The server also purges everything
// they staged behind it — a void leaves no draft and no card images.
export async function voidIntakeLink(id) {
  return await api.post(`/api/intake-links/${id}/void`, {});
}
export async function getIntakeLinkDetail(id) {
  return await api.get(`/api/intake-links/${id}/detail`);
}
// Presigned (15-min) download URL for a retained card image — the recovery
// copy kept after completion in case the Elation upload was lost.
export async function getIntakeLinkDocumentUrl(id, docId) {
  return await api.get(`/api/intake-links/${id}/documents/${docId}/download`);
}
export function absoluteUrl(path) {
  return `${window.location.origin}${path}`;
}

// ── The self-scheduled appointment (self-scheduling PR5, plan §3c/§6d) ──────
// All three actions answer { appointment } (the row as it now stands; `link` too
// when a flag came off) or 202 { pending: true, appointment } when Elation did
// not answer and the recovery sweep will settle it. A refusal throws with
// err.status and err.body = { error, code, appointment }: `slot_taken` (409) is
// the one the dialog handles in place.
export async function cancelLinkAppointment(id) {
  return await api.post(`/api/intake-links/${id}/appointment/cancel`, {});
}
// Time-only: the visit type never changes on a reschedule.
export async function rescheduleLinkAppointment(id, start) {
  return await api.post(`/api/intake-links/${id}/appointment/reschedule`, { start });
}
export async function retryLinkAppointment(id) {
  return await api.post(`/api/intake-links/${id}/appointment/retry`, {});
}
// Open slots for the reschedule dialog: the wizard's shape
// ({ timezone, days:[{date, slots:[{start,end}]}], unavailable, message }) plus
// visitTypes and maxAdvanceDays. `excludeLinkId` keeps the appointment being
// moved from hiding its own slot.
export async function getSchedulingAvailability({ from, to, visitTypeId, excludeLinkId } = {}) {
  const q = new URLSearchParams();
  if (from) q.set('from', from);
  if (to) q.set('to', to);
  if (visitTypeId) q.set('visitTypeId', visitTypeId);
  if (excludeLinkId) q.set('excludeLinkId', excludeLinkId);
  return await api.get(`/api/intake-links/availability?${q.toString()}`);
}
